export default __webpack_public_path__ + "static/media/Guess.0a6df42d.png";